import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { db } from '../firebase';
import { doc, onSnapshot } from 'firebase/firestore';
import { useAuth } from './AuthContext';

const RolesContext = createContext(null);

export const RolesProvider = ({ children }) => {
  const { user } = useAuth();
  const [roles, setRoles] = useState({ isMod: false });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!user) {
      setRoles({ isMod: false });
      setError(null);
      return;
    }
    setLoading(true);
    setError(null);
    const ref = doc(db, 'roles', user.uid);
    const unsub = onSnapshot(ref, (snap) => {
      const data = snap.data() || {};
      setRoles({ isMod: !!data.isMod });
      setLoading(false);
    }, (err) => {
      setError(err);
      setLoading(false);
    });
    return () => unsub();
  }, [user]);

  const value = useMemo(() => ({
    ...roles,
    loadingRoles: loading,
    rolesError: error,
  }), [roles, loading, error]);

  return (
    <RolesContext.Provider value={value}>
      {children}
    </RolesContext.Provider>
  );
};

export const useRoles = () => {
  const ctx = useContext(RolesContext);
  if (!ctx) throw new Error('useRoles must be used within a RolesProvider');
  return ctx;
};
